@if (resource()) {
  <div class="room-detail">
    <div class="row">
      <div class="col col-12 col-md-6">
        <div class="row">
          <div class="col-md-12">
            @if (resource().isAssignedTo) {
              <div class="assigned-to-label">
                <cue-icon [icon]="resource().isAssignedTo | assignTo"></cue-icon>
                {{ resource().isAssignedTo | assignToTranslateKey | transloco }}
              </div>
            }
            @if (resource().id | resourceExternalUrl; as resourceUrl) {
              <button class="small" (click)="navigateToResourceDetailInAssist(resourceUrl)">
                <cue-icon
                  [icon]="ICONS.cueExternalLink"
                  [title]="translation.outlookAddin.cueExternalLink | transloco"
                ></cue-icon>
                Open in Assist
              </button>
            }
            <table class="popup-table">
              @if (resource().resourceDisplayNameForApp && resource().displayName) {
                <tr>
                  <th>
                    <div>
                      {{ translation.leftMenu.name | transloco }}
                    </div>
                  </th>
                  <td>{{ resource().displayName }}</td>
                </tr>
              }
              <tr>
                <th>
                  <div>
                    {{ translation.leftMenu.type | transloco }}
                  </div>
                </th>
                <td>{{ resource().resourceTypeName }}</td>
              </tr>
              <tr>
                <th>
                  <div>
                    {{ translation.resourceDetail.capacity | transloco }}
                  </div>
                </th>
                <td>
                  {{ resource().capacity !== null ? resource().capacity : (translation.common.unlimited | transloco) }}
                </td>
              </tr>
              @for (simpleFilter of getSimpleFiltersByResourceTypeId(resource()); track simpleFilter) {
                <tr>
                  <th>
                    <div>
                      {{ simpleFilter.name }}
                    </div>
                  </th>
                  <td>
                    @if (simpleFilter.value === true) {
                      <cue-icon [icon]="ICONS.cueCheck" class="correct"></cue-icon>
                    }

                    @if (simpleFilter.value === false) {
                      <cue-icon [icon]="ICONS.cueClose" class="incorrect"></cue-icon>
                    }

                    @if (simpleFilter.value !== true && simpleFilter.value !== false) {
                      {{ simpleFilter.value }}
                    }
                  </td>
                </tr>
              }
            </table>
            @if (resource().workingHours?.workingHoursSetting) {
              <div class="working-hours">
                <cue-working-hours expensionPanelClass="show-panel show-panel--small" [workingHourInfo]="resource()" />
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col col-12 col-md-6">
        <div class="row">
          <div class="col-md-12">
            @if (resource().breadcrumb) {
              <div class="breadcrumb-container">
                @for (item of resource().breadcrumb; track item; let i = $index) {
                  <span class="breadcrumb">
                    @if (i !== 0) {
                      <cue-icon [icon]="ICONS.cueArrowRight"></cue-icon>
                    }
                    <span class="part">{{ item.displayName }}</span>
                  </span>
                }
              </div>
            }
            <addin-resource-map
              [geoData]="resource().mapGeoData"
              [imageSrc]="resource().mapUrl"
              [resourceId]="resource().guid"
            ></addin-resource-map>
          </div>
        </div>
        <cue-file-gallery [files]="resource().files | photosToFile" />
      </div>
    </div>
  </div>
}
